import { useEffect } from "react";
import { useState } from "react";
import { Col, Container, Row, Image, Button, Media, Badge, ListGroup } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { getNewSlug, findNewsRecents, getAllPartiners, getProductReviews, getUser, deleteReview } from "../../../services/api";
import { currency, timeAgo, validDateCupom, valueToRate } from "../../../utils/mappers";
import "./styles.scss";
import GoogleAd from "../../../components/GoogleAds/GoogleAd"; // ajuste o caminho conforme sua estrutura

//import ReactQuill from 'react-quill';
//import 'react-quill/dist/quill.snow.css';
import { FiTruck } from "react-icons/fi";
import { MdEdit, MdWhatsapp, MdCheck, MdDelete } from "react-icons/md";
import { FaTelegramPlane, FaBolt, FaCut } from 'react-icons/fa';
import LoadingIndicator from "../../../components/LoadingIndicator";
import NotFound from "../../NotFound";
import Footer from "../../../components/Footer";
import { ModalCentered } from "../../../components/AvaliationModal";
import useAuth from "../../../contexts/auth";


import { useHistory } from "react-router-dom";
import useNotification from "../../../contexts/notification";
import CardNews from "../../../components/CardNews";
//import ConfirmCheckPriceModal from "./ConfirmCheckPriceModal";

export default function New() {
  const { slug } = useParams();
  const { user } = useAuth();
  const [idNew, setNewId] = useState(null);
  const [newData, setNewData] = useState(null);
  const [newsR, setNewsR] = useState([]);
  const [reviews, setReviews] = useState(null);
  const [loading, setLoading] = useState(true);

  const googleAd = {
    imageUrl: "https://via.placeholder.com/300x600", // Substitua pelo link correto da imagem do anúncio
    url: "https://google.com" // Substitua pelo URL do anúncio
  };


  const [confirmModalShow, setConfirmModalShow] = useState(false);
  const { setMessage } = useNotification();
  const [editRate, setEditRate] = useState(null);
  const [rates, setRates] = useState([]); // Supomos que você tem um estado para as avaliações

  const history = useHistory();

  const [showReviewModal, setShowReviewModal] = useState(false);
  const handleEdit = (rate) => {
    setEditRate(rate);
    setShowReviewModal(true);
  };



  function refresh() {

    getProductReviews(idNew).then(
      (data) => {
        setReviews(data);
        setLoading(false);
      },
      (err) => {
        setReviews([]);
        setLoading(false);
      }
    );
  }

  useEffect(() => {
    getNewSlug(slug).then(

      (data) => {
        console.log(data.badges[0].name)
        setNewData(data);

        setNewId(data.new.id)
        findNewsRecents().then((data) => {
          setNewsR(data)

        });
        getProductReviews(data.new.id).then(
          (data) => {

            setReviews(data);
            setLoading(false);
          },
          (err) => {
            setReviews([]);
            setLoading(false);
          }
        );


        /*getProductReviews(id).then(
          (data) => {
 
            setReviews(data);
            setLoading(false);
          },
          (err) => {
            setReviews([]);
            setLoading(false);
          }
        );*/
      },
      (err) => {
        setLoading(false);
      }
    );
  }, [slug]);

  if (loading) {
    return <LoadingIndicator />;
  }

  if (newData === null) {
    return <NotFound isComponent />;
  }







  return (
    <>

      <Container className="news-container">
        <Row className="news-header">
          <Col md={12}>
            <Badge
              style={{
                backgroundColor: newData.badges[0].color,
                color: "black",
                padding: "5px 10px",
                fontSize: "14px",
                fontWeight: "bold",
                marginBottom: "10px",
              }}
            >
              {newData.badges[0].name}
            </Badge>
            <h1 className="news-title">{newData.new.name}</h1>
            <p className="news-author-date">
              <strong>Por {newData.new.user.name}</strong>, Publicado em{" "}
              {new Date(newData.new.created_at).toLocaleDateString()}
            </p>

            <div className="news-separator"></div>
          </Col>
        </Row>

        {/* Conteúdo e lateral */}
        <Row>
          {/* Notícia */}
          <Col md={8}>
            <Image
              src={newData.new.image_url}
              alt={newData.new.name}
              className="news-image-main mx-auto d-block"
            />

            {newData?.new?.description && (
              <div
                className="news-description"
                dangerouslySetInnerHTML={{ __html: newData.new.description }}
              />
            )}
            {/*
            <div className="news-separator"></div>
*/}
            {/* Comentários */}
            <div className="comments-section mt-4">
              <Button
                size="sm"
                variant="outline-primary"
                className="mb-3"
                onClick={() => setShowReviewModal(true)}
              >
                Comentar Nóticia <MdEdit />
              </Button>
              <hr />
              <ListGroup variant="flush">
                {reviews.Avaliacoes.map((rate, index) => (
                  <UserRate
                    key={index}
                    rate={rate}
                    onEdit={handleEdit}
                    user={user}
                    refresh={refresh}
                  />
                ))}
                {reviews.Avaliacoes.length === 0 && (
                  <p className="text-muted text-center">
                    Não há comentários para esta notícia
                  </p>
                )}
              </ListGroup>
            </div>
          </Col>

          {/* Lateral: Mais Recentes */}
          <Col xs={12} md={4} className="recent-news">

            <h2 className="mb-3">Mais Recentes</h2>
            <div className="news-list">
              {newsR.length > 0 ? (

                newsR.slice(0, 4).map((item, index) => (
                  <CardNews key={index} newsItem={item} small />
                ))

              ) : (
                <p>Nenhuma notícia recente disponível.</p>
              )}
            </div>
            <div className="mt-4">
              <GoogleAd />
            </div>
          </Col>
        </Row>
      </Container>

      {
        <ModalCentered
          id={idNew}
          show={showReviewModal}
          onHide={() => {
            refresh();
            setShowReviewModal(false);
            setEditRate(null);
          }}
          editRate={editRate}
        />}
      <div className="footer">
        <Footer />
      </div>
    </>
  );
}
export function UserRate({ rate, onEdit, onDelete, user, refresh }) {

  const handleDelete = () => {
    deleteReview(rate).then(() => {
      refresh();
    });
  };

  const renderRating = () => {
    return (
      <div className="d-flex align-items-center">
        <span className="ml-2">{valueToRate(rate.userRate)}</span>
      </div>
    );
  };
  const getAvatar = (name) => {
    return name ? name.charAt(0).toUpperCase() : "U"; // Pega a primeira letra do nome
  };
  const timeSince = (date) => {
    const seconds = Math.floor((new Date() - new Date(date)) / 1000);
    let interval = Math.floor(seconds / 31536000);

    if (interval >= 1) {
      return `há ${interval} anos`;
    }
    interval = Math.floor(seconds / 2592000);
    if (interval >= 1) {
      return `há ${interval} meses`;
    }
    interval = Math.floor(seconds / 86400);
    if (interval >= 1) {
      return `há ${interval} dias`;
    }
    interval = Math.floor(seconds / 3600);
    if (interval >= 1) {
      return `há ${interval} horas`;
    }
    interval = Math.floor(seconds / 60);
    if (interval >= 1) {
      return `há ${interval} minutos`;
    }
    return `agora mesmo`;
  };

  // Dentro do componente


  const idRate = rate.user_id != null ? rate.user_id.id : null;
  const canEditOrDelete = user && (user.id === idRate || user.type === 'admin');
  const name = rate.user_id !== null ? rate.user_name : rate.user_name;
  return (
    <Media className="my-2">
      <div className="mr-3">
        {/* Avatar em formato circular */}
        <div
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            backgroundColor: "#e9ecef", // Cor de fundo do avatar (cinza claro)
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "24px",
            color: "#6c757d", // Cor do texto do avatar (cinza escuro)
          }}
        >
          {getAvatar(name)}
        </div>
      </div>
      <Media.Body>
        {renderRating()}
        <div className="d-flex align-items-center">
          <p className="my-0 font-weight-bold">{name}</p>
          {canEditOrDelete && (
            <div className="d-flex ml-2">
              <Button size="sm" variant="outline-primary" onClick={() => onEdit(rate)} className="mr-1">
                Editar <MdEdit />
              </Button>
              <Button size="sm" variant="outline-danger" onClick={handleDelete} className="mr-1">
                Excluir
                <MdDelete />
              </Button>
            </div>
          )}
        </div>
        <p className="text-muted">{rate.review}</p>
        <small className="text-muted">
          {timeSince(rate.createdAt)}
        </small>
      </Media.Body>
    </Media>
  );
}
